export const en = {
    'words': 'WORDS',
    'seat':'SEAT',
    'region':'REGION',
    'allegiances':'ALLEGIANCES',
    'religion':'RELIGION',
    'fundation':'FUNDATION',
    'siblings': 'SIBLINGS',
    'titles': 'TITLES',
    'appearances': 'APPEARANCES',
    'father': 'FATHER',
    'house': 'HOUSE',
    'characters':'CHARACTERS',
    'chronology':'CHRONOLOGY',
    'houses': 'HOUSES',
    'game': 'GAME',
    'of': 'OF',
    'thrones': 'THRONES',
}

